import {
  FilterStudentsByCurrentYearUseCase,
  GetAllStudentUseCase,
  GetListOfCareersUseCase,
} from '@/application/student';
import { AggregateStudentRiskCountersUseCase } from '@/application/student/aggregateStudentRiskCountersUseCase';
import { CalculateStudentStatisticsUseCase } from '@/application/student/calculateStudentStatisticsUseCase';
import { FilterStudentsUseCase } from '@/application/student/filterStudentsUseCase';
import { ProcessStudentsUseCase } from '@/application/student/processStudentsUseCase';
import { studentApiRepository } from '@/infra';

// variables privadas del módulo
let _getAllStudentUseCase: GetAllStudentUseCase | null = null;
let _getListOfCareersUseCase: GetListOfCareersUseCase | null = null;
let _processStudentsUseCase: ProcessStudentsUseCase | null = null;
let _filterStudentsUseCase: FilterStudentsUseCase | null = null;
let _calculateStudentStatisticsUseCase: CalculateStudentStatisticsUseCase | null =
  null;
let _aggregateStudentRiskCountersUseCase: AggregateStudentRiskCountersUseCase | null =
  null;
let _filterStudentByCurrentYearUseCase: FilterStudentsByCurrentYearUseCase | null =
  null;

/**
 * Función que inyecta una instancia de getAllStudentUseCase
 * Refactorizada para usar studentDataService (interfaz granular)
 */
export const getAllStudentUseCase = (): GetAllStudentUseCase => {
  if (!_getAllStudentUseCase)
    _getAllStudentUseCase = new GetAllStudentUseCase(studentApiRepository);

  return _getAllStudentUseCase;
};

/**
 * Función que inyecta una instancia de getListOfCareersUseCase
 */
export const getListOfCareersUseCase = (): GetListOfCareersUseCase => {
  if (!_getListOfCareersUseCase) {
    _getListOfCareersUseCase = new GetListOfCareersUseCase();
  }
  return _getListOfCareersUseCase;
};

/**
 * Función que inyecta ProcessStudentsUseCase
 * Cumple SRP - separa lógica de procesamiento del store
 */
export const getProcessStudentsUseCase = (): ProcessStudentsUseCase => {
  if (!_processStudentsUseCase) {
    _processStudentsUseCase = new ProcessStudentsUseCase();
  }
  return _processStudentsUseCase;
};

/**
 * Función que inyecta FilterStudentsUseCase
 * Extrae lógica compleja de filtrado que estaba en hooks UI
 */
export const getFilterStudentsUseCase = (): FilterStudentsUseCase => {
  if (!_filterStudentsUseCase) {
    _filterStudentsUseCase = new FilterStudentsUseCase();
  }
  return _filterStudentsUseCase;
};

/**
 * Función que inyecta CalculateStudentStatisticsUseCase
 * Extrae lógica de cálculo de estadísticas de useStudent.hook
 */
export const getCalculateStudentStatisticsUseCase =
  (): CalculateStudentStatisticsUseCase => {
    if (!_calculateStudentStatisticsUseCase) {
      _calculateStudentStatisticsUseCase =
        new CalculateStudentStatisticsUseCase();
    }
    return _calculateStudentStatisticsUseCase;
  };

/**
 * Función que inyecta AggregateStudentRiskCountersUseCase
 * Extrae lógica de agregación de riesgos de useRiskCounter.hook
 */
export const getAggregateStudentRiskCountersUseCase =
  (): AggregateStudentRiskCountersUseCase => {
    if (!_aggregateStudentRiskCountersUseCase) {
      _aggregateStudentRiskCountersUseCase =
        new AggregateStudentRiskCountersUseCase();
    }
    return _aggregateStudentRiskCountersUseCase;
  };

export const filterStudentsByCurrentYearUseCase =
  (): FilterStudentsByCurrentYearUseCase => {
    if (!_filterStudentByCurrentYearUseCase) {
      _filterStudentByCurrentYearUseCase =
        new FilterStudentsByCurrentYearUseCase();
    }

    return _filterStudentByCurrentYearUseCase;
  };

/**
 * Función para resetear las instancias
 */
export const resetStudentContainer = (): void => {
  _getAllStudentUseCase = null;
  _getListOfCareersUseCase = null;
  _processStudentsUseCase = null;
  _filterStudentsUseCase = null;
  _calculateStudentStatisticsUseCase = null;
  _aggregateStudentRiskCountersUseCase = null;
  _filterStudentByCurrentYearUseCase = null;
};
